import { Center, Container, Paper, Stack, Text, Title, Button, Group } from '@mantine/core';
import { IconClock, IconPhone, IconMail } from '@tabler/icons-react';
import { useAuthStore } from '@/store/auth';
import { useNavigate } from 'react-router-dom';

export default function PendingApproval() {
  const logout = useAuthStore((s) => s.logout);
  const user = useAuthStore((s) => s.user);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <Center mih="100vh" bg="gray.0">
      <Container size={500} w="100%">
        <Stack align="center" gap={4} mb="lg">
          <img src="/logo.png" alt="Standard Produce Co." style={{ height: 120 }} />
        </Stack>

        <Paper shadow="md" p={30}>
          <Stack align="center" gap="md">
            <IconClock size={48} color="var(--mantine-color-yellow-6)" />
            <Title order={3} ta="center">
              Account Pending Approval
            </Title>
            <Text c="dimmed" ta="center" size="sm">
              Thank you for registering
              {user?.customer?.name ? `, ${user.customer.name}` : ''}! Your account
              is currently under review. Our team will verify your information and
              activate your account shortly.
            </Text>

            <Paper p="md" w="100%" bg="gray.0">
              <Text fw={600} size="sm" mb="xs">
                Need to get started sooner? Contact our office:
              </Text>
              <Stack gap={6}>
                <Group gap="xs">
                  <IconPhone size={16} color="var(--mantine-color-brand-6)" />
                  <Text size="sm">(434) 295-5171</Text>
                </Group>
                <Group gap="xs">
                  <IconMail size={16} color="var(--mantine-color-brand-6)" />
                  <Text size="sm">info@standardproduce.com</Text>
                </Group>
              </Stack>
            </Paper>

            <Button variant="subtle" color="gray" onClick={handleLogout} mt="sm">
              Sign out
            </Button>
          </Stack>
        </Paper>
      </Container>
    </Center>
  );
}
